var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"star-display",class:_vm.sizeClass},[(_vm.displayValue == null)?_c('span',{staticClass:"star-display-empty"},[_vm._v("—")]):_c('el-rate',{attrs:{"value":_vm.displayValue,"max":_vm.max,"disabled":"","colors":_vm.starColors,"void-color":"#C0C4CC","disabled-void-color":"#E4E7ED"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }